
import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { IFilterContainerState } from "./filter";
import {
    applyFacets,
    applySearch,
    applySingleFacet,
    applySorting,
    clearFilter,
    loadMore,
    removeSingleFacet,
    updateFilterResult,
} from './filter.actions';

const mapState = ({ filter }: IStoreState): IFilterContainerState => ({ ...filter });

const actions = {
    applyFacets,
    applySearch,
    applySingleFacet,
    applySorting,
    clearFilter,
    loadMore,
    removeSingleFacet,
    updateFilterResult,
};

export type IFilterContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [filterContainer, connectWithFilter, useFilter] = generateContainer(mapState, actions);
